import classNames from 'classnames';
import React, { useCallback } from 'react';
import { HasClassName } from '../component-utils';
import './Toggle.scss';

interface Props extends HasClassName {
  disabled?: boolean
  value: boolean
  onChange(value: boolean): void
}

export default function Toggle({ className, value, disabled, onChange, children }: React.PropsWithChildren<Props>) {
  const onClick = useCallback(() => {
    !disabled && onChange && onChange(!value)
  }, [disabled, onChange, value])

  return <button className={classNames('Toggle', className, value && 'checked', disabled && 'disabled')} onClick={onClick}>
    <div className={classNames('Toggle-toggle', disabled && 'disabled')} />
    {children}
  </button>
}
